import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class StoreTitleService {
  baseUrl = '';

  constructor(
    private http: HttpClient,
    private titleService: Title,
  ) {
    this.baseUrl = environment.baseApiUrl;
  }

  /**
   * Gets the store title from the API and sets the document title.
   * Appends ' - Course' to the store title.
   */
  setStoreTitle(): void {
    const subscription = this.getStoreTitle().subscribe((storeTitle: string | null) => {
      if (storeTitle) {
        this.titleService.setTitle(`${storeTitle} - Course`);
      } else {
        this.titleService.setTitle('Course'); // Fallback title if store title is not available
      }
      subscription.unsubscribe();
    });
  }

  /**
   * Gets the store title from the API.
   */
  private getStoreTitle(): Observable<string | null> {
    return this.http
      .get<{ title: string }>(`${this.baseUrl}store-title`, { withCredentials: true })
      .pipe(
        map((response) => response?.title ?? null),
        catchError(() => of(null)),
      );
  }
}
